export function importAll(r) {
  return r
    .keys()
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))
    .map((key) => {
      const src = r(key);
      return {
        src: src,
        alt: key.replace("./", "").replace(/\.(jpg|jpeg|png|webp)$/, ""),
      };
    });
}
